<template>
  <section
    class="md:py-12 py-12 bg-gradient-to-r from-primary-color to-primary-dark"
  >
    <div class="max-w-5xl px-10 mx-auto xl:max-w-5xl">
      <div class="flex flex-col items-center justify-between">
        <div class="relative text-gray-100 text-center" data-aos="fade-right">
          <h2 class="text-[23px] md:text-2xl lg:text-3xl font-semibold">
            {{ title }}
          </h2>
          <p class="mt-2 text-[18px] lg:text-xl">{{ text }}</p>
        </div>
        <div
          data-aos="fade-left"
          class="w-full flex items-center justify-center"
        >
          <a
            v-if="target"
            :href="buttonLink"
            :target="target"
            class="w-full py-4 mt-10 btn-white max-w-60"
            >{{ buttonText }}
          </a>
          <inertia-link
            v-else
            :href="buttonLink"
            class="w-full py-4 mt-10 btn-white max-w-60"
          >
            {{ buttonText }}
          </inertia-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: String,
    text: String,
    buttonText: String,
    buttonLink: String,
    target: String,
  },
};
</script>